export default __webpack_public_path__ + "7aab2e630fdc2509c95bfba586222b3f.png";